import { $themeBreakpoints } from '@themeConfig'
import { $themeConfig } from '@themeConfig'
import store from '@/store'
import axiosIns from '@axios'

export default {
    namespaced: true,
    state: {
        percentCompleted: 0,
        isLoading: true,
        domainHost: $themeConfig.app.domainPath,
        windowWidth: 0,
        shallShowOverlay: false,
        createButtonAndGlobalSearch: {
            isActive: false,
            isbuttonActive: false,
            
            text: '',
            fetchingFunction: null,

            placeHolder: '',
            value: '',
            key: '',
            items: '',
            filterFunc: null
        },
        placeHolderImage: '/media/placeholder/image-placeholder.jpg',
        placeHoldervideo: '/media/placeholder/video-placeholder.jpg',
        placeHolderpdf: '/media/placeholder/pdf-placeholder.png',
        cancelTokenSource: axiosIns.CancelToken.source(),
        shownCloseRequest: false
    },
    getters: {
        currentBreakPoint: state => {
            const { windowWidth } = state
            if (windowWidth >= $themeBreakpoints.xl) return 'xl'
            if (windowWidth >= $themeBreakpoints.lg) return 'lg'
            if (windowWidth >= $themeBreakpoints.md) return 'md'
            if (windowWidth >= $themeBreakpoints.sm) return 'sm'
            return 'xs'
        },
        placeHolderImage(state) {
            return state.placeHolderImage;
        },
        placeHoldervideo(state) {
            return state.placeHoldervideo;
        },
        placeHolderpdf(state) {
            return state.placeHolderpdf;
        },
        isLoading(state) {
            return state.isLoading;
        },
        percentCompleted(state) {
            return state.percentCompleted;
        },
        cancelTokenSource(state) {
            return state.cancelTokenSource;
        },
        shownCloseRequest(state) {
            return state.shownCloseRequest;
        },
        domainHost(state) {
            return state.domainHost;
        }
    },
    mutations: {
        UPDATE_WINDOW_WIDTH(state, val) {
            state.windowWidth = val
        },
        TOGGLE_OVERLAY(state, val) {
            state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
        },
        UPDATE_CREATE_BUTTON_AND_GLOBALE_SEARCH(state, newCreateButtonAndGlobalSearch) {
            Object.assign(state.createButtonAndGlobalSearch, newCreateButtonAndGlobalSearch)
        },
        Set_Loading(state, is) {
            state.isLoading = is
            state.percentCompleted = 0
        },
        Percent_Completed(state, payload) {
            state.percentCompleted = payload
        },
        Set_Cancel_Token(state) {
            state.cancelTokenSource = axiosIns.CancelToken.source()
        },
        Shown_Close_Request(state, is) {
            state.shownCloseRequest = is
        }
    },
    actions: {
        pageChanged(context, pageInfo) {
            const firstPageItem = pageInfo.pageLength * (pageInfo.currentPage - 1)
            return pageInfo.items.slice(firstPageItem, firstPageItem + pageInfo.pageLength)
        },
        setLoading({commit}, is) {
            commit('Set_Loading', is)
        },
        filterItems({state}, payload) {
            console.log(payload);
            const { items, key } = payload;
            const searchTerm = (state.createButtonAndGlobalSearch.value || "").toLocaleLowerCase();
        
            return store.getters[items].filter((item) => {
                return item[key].toLocaleLowerCase().includes(searchTerm);  // Case-insensitive search
            });
        },
        filterMutliColumnsItems({ state }, payload) {
            console.log(payload);
            const { items, keys } = payload; // Destructure keys as an array
            const searchTerm = (state.createButtonAndGlobalSearch.value || "").toLocaleLowerCase();
        
            return store.getters[items].filter((item) => {
                // Check if the search term is included in any of the specified keys
                return keys.some(key => {

                    if(item[key])
                    return item[key].toLocaleLowerCase().includes(searchTerm);
                });
            });
        },
        setPercentCompleted({commit}, payload) {
            commit("Percent_Completed", payload)
        },
        setCancelToken({commit}) {
            commit("Set_Cancel_Token")
        },
        shownCloseRequest({commit}, is) {
            commit("Shown_Close_Request", is)
        },
    },
}
